import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'
import { Dialogs, useDialogs } from '../../../sharedComponents/src/Contexts/DialogsContext'
import AnimatedDialog from '../../../sharedComponents/src/Dialogs/Common/AnimatedDialog'
import { analyticsManager } from '../../../sharedComponents/src/globalHeader/services/analytics/AnalyticsManager'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreActions } from '../../../store/hooks'

const FinishFtueDialog = () => {
    const setDrawerOpen = useStoreActions((state) => state.setDrawerOpen)
    const setIsDrawerMenuOpen = useStoreActions((state) => state.setIsDrawerMenuOpen)

    const { isMobile } = useScreenSize()
    const { unregisterDialog } = useDialogs()
    const navigate = useNavigate()

    const onKeepPlaying = () => {
        analyticsManager.dispatchEvent('ftueEndDialogue', {
            buttonPressed: 'keepPlaying',
        })
        unregisterDialog(Dialogs.FINISH_PUZZLES_FTUE)
    }

    const onExploreMore = () => {
        setIsDrawerMenuOpen(true)
        setDrawerOpen('open')
        navigate('/')
        analyticsManager.dispatchEvent('ftueEndDialogue', {
            buttonPressed: 'exploreMore',
        })
        unregisterDialog(Dialogs.FINISH_PUZZLES_FTUE)
    }

    const onClose = () => {
        analyticsManager.dispatchEvent('ftueEndDialogue', {
            buttonPressed: 'close',
        })
    }

    return (
        <AnimatedDialog
            name={Dialogs.FINISH_PUZZLES_FTUE}
            borderColor="secondary.main"
            onClose={onClose}
            paperProps={{
                animationOrImage: {
                    src: '/assets/images/congrats.webp',
                    verticalPosition: { xs: '-190px', md: '-250px' },
                    horizontalPosition: { xs: '-3%', md: '15%' },
                },
                closeIcon: {
                    verticalPosition: { xs: '-140px', md: '-45px' },
                    horizontalPosition: { xs: 0, md: '20px' },
                },
            }}
        >
            <Stack gap={2}>
                {/* Title */}
                <Typography
                    variant={isMobile ? 'h5' : 'h2'}
                    color="secondary.main"
                    textTransform="uppercase"
                    sx={{ px: { xs: 0, md: 7 } }}
                >
                    You completed your first puzzles
                </Typography>

                {/* Content */}
                <Stack gap={1}>
                    <Typography variant={isMobile ? 'body2' : 'h6'}>
                        Would you like to continue solving puzzles?
                    </Typography>
                    <Typography variant={isMobile ? 'body2' : 'h6'}>Or explore other features?</Typography>
                </Stack>

                {/* Actions */}
                <Stack direction="row" gap={isMobile ? 1 : 3}>
                    <Button variant="contained" fullWidth size={isMobile ? 'small' : 'large'} onClick={onExploreMore}>
                        explore more
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        size={isMobile ? 'small' : 'large'}
                        onClick={onKeepPlaying}
                    >
                        keep playing
                    </Button>
                </Stack>
            </Stack>
        </AnimatedDialog>
    )
}

export default FinishFtueDialog
